import React from "react";
import { Button, Chip, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import GetAppIcon from "@material-ui/icons/GetApp";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import RoomOutlinedIcon from "@material-ui/icons/RoomOutlined";
import PhoneIphoneOutlinedIcon from "@material-ui/icons/PhoneIphoneOutlined";
import LanguageOutlinedIcon from "@material-ui/icons/LanguageOutlined";
import CheckCircleOutlineOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";
import MemoryIcon from "@material-ui/icons/Memory";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import CodeOutlinedIcon from "@material-ui/icons/CodeOutlined";
import ArrowForwardRoundedIcon from "@material-ui/icons/ArrowForwardRounded";

import { Link } from "react-router-dom";
import Title from "../components/title";
import { getTranslate } from "../localization";
import aboutImg from "../assets/images/AboutImg.jpg";

const BIRTH_DATE = {
  year: 1996,
  month: 12,
  day: 21,
};

function calculateAge() {
  const today = new Date();
  let age = today.getFullYear() - BIRTH_DATE.year;

  const birthdayHasNotOccurred =
    today.getMonth() + 1 < BIRTH_DATE.month ||
    (today.getMonth() + 1 === BIRTH_DATE.month && today.getDate() < BIRTH_DATE.day);

  if (birthdayHasNotOccurred) {
    age -= 1;
  }

  return age;
}

function toPersianDigits(value) {
  return String(value).replace(/\d/g, (digit) => "۰۱۲۳۴۵۶۷۸۹"[digit]);
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: "100vh",
    padding: "52px 44px 90px",
    direction: theme.direction,
    textAlign: theme.direction === "rtl" ? "right" : "left",
    [theme.breakpoints.down("sm")]: {
      padding: "34px 22px 64px",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "28px 16px 56px",
    },
  },
  inner: {
    width: "min(100%, 1320px)",
    margin: "0 auto",
  },
  heroCard: {
    position: "relative",
    padding: 20,
    borderRadius: 26,
    overflow: "hidden",
    background: "linear-gradient(145deg,rgba(14,25,48,.94),rgba(8,16,31,.97))",
    border: "1px solid rgba(96,119,166,.18)",
    boxShadow: "0 22px 55px rgba(0,0,0,.22)",
    "&::before": {
      content: '""',
      position: "absolute",
      width: 320,
      height: 320,
      top: -190,
      right: theme.direction === "rtl" ? "auto" : -170,
      left: theme.direction === "rtl" ? -170 : "auto",
      borderRadius: "50%",
      background: "radial-gradient(circle,rgba(22,139,255,.13),transparent 68%)",
      pointerEvents: "none",
    },
    [theme.breakpoints.down("xs")]: {
      padding: 14,
      borderRadius: 20,
    },
  },
  imageWrap: {
    position: "relative",
    minHeight: 420,
    height: "100%",
    borderRadius: 21,
    overflow: "hidden",
    border: "1px solid rgba(95,117,163,.18)",
    background: "#091225",
    [theme.breakpoints.down("md")]: {
      minHeight: 330,
    },
    [theme.breakpoints.down("xs")]: {
      minHeight: 240,
    },
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  content: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    minWidth: 0,
    padding: theme.direction === "rtl" ? "10px 18px 10px 4px" : "10px 4px 10px 18px",
    [theme.breakpoints.down("md")]: {
      padding: "14px 2px 2px",
    },
  },
  nameTitle: {
    color: "#f8fafc",
    fontWeight: 850,
    fontSize: "clamp(2rem,3.5vw,3.15rem)",
    lineHeight: 1.35,
    marginBottom: 13,
    textAlign: theme.direction === "rtl" ? "right" : "left",
    overflowWrap: "break-word",
  },
  accent: {
    color: "#2596ff",
  },
  description: {
    color: "#9aa8bb",
    fontSize: 14,
    lineHeight: 2,
    marginBottom: 16,
    textAlign: theme.direction === "rtl" ? "right" : "left",
  },
  journeyNote: {
    padding: "12px 14px",
    marginBottom: 17,
    borderRadius: 13,
    color: "#b7c5d7",
    fontSize: 12,
    lineHeight: 1.8,
    background: "rgba(22,139,255,.05)",
    border: "1px solid rgba(22,139,255,.14)",
  },
  tags: {
    display: "flex",
    flexWrap: "wrap",
    gap: 7,
    marginBottom: 20,
  },
  tag: {
    height: 29,
    color: "#b5c5d9",
    fontSize: 10,
    background: "rgba(22,139,255,.055)",
    border: "1px solid rgba(22,139,255,.15)",
  },
  infoItem: {
    display: "flex",
    alignItems: "flex-start",
    minHeight: 74,
    padding: "12px 13px",
    borderRadius: 15,
    background: "rgba(255,255,255,.018)",
    border: "1px solid rgba(148,163,184,.095)",
    direction: theme.direction,
  },
  infoIcon: {
    flexShrink: 0,
    color: "#2698ff",
    fontSize: 20,
    marginTop: 2,
    marginRight: theme.direction === "rtl" ? 0 : 11,
    marginLeft: theme.direction === "rtl" ? 11 : 0,
  },
  infoLabel: {
    color: "#74839a",
    fontSize: 10,
    marginBottom: 3,
  },
  infoValue: {
    color: "#e1e8f2",
    fontSize: 12,
    fontWeight: 700,
    lineHeight: 1.65,
    overflowWrap: "anywhere",
  },
  actions: {
    display: "flex",
    flexWrap: "wrap",
    gap: 10,
    marginTop: 21,
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  primaryButton: {
    minHeight: 46,
    padding: "8px 18px",
    borderRadius: 11,
    color: "#fff",
    fontSize: 11,
    fontWeight: 800,
    background: "linear-gradient(135deg,#168bff,#2e9bff)",
    boxShadow: "0 10px 28px rgba(22,139,255,.20)",
    "&:hover": {
      transform: "translateY(-2px)",
      background: "linear-gradient(135deg,#2495ff,#52b2ff)",
    },
  },
  secondaryButton: {
    minHeight: 46,
    padding: "8px 18px",
    borderRadius: 11,
    color: "#c7d3e3",
    fontSize: 11,
    fontWeight: 800,
    border: "1px solid rgba(148,163,184,.16)",
    background: "rgba(255,255,255,.022)",
    "&:hover": {
      transform: "translateY(-2px)",
      color: "#fff",
      borderColor: "rgba(22,139,255,.34)",
      background: "rgba(22,139,255,.06)",
    },
  },
  buttonInner: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 9,
    direction: theme.direction,
  },
  arrowIcon: {
    transform: theme.direction === "rtl" ? "scaleX(-1)" : "none",
  },
  coreSection: {
    marginTop: 48,
  },
  coreCard: {
    position: "relative",
    height: "100%",
    minHeight: 250,
    padding: 24,
    borderRadius: 21,
    overflow: "hidden",
    background: "linear-gradient(150deg,rgba(16,28,53,.92),rgba(9,17,33,.96))",
    border: "1px solid rgba(102,123,170,.16)",
    boxShadow: "0 14px 34px rgba(0,0,0,.14)",
    transition: "transform .25s ease, border-color .25s ease, box-shadow .25s ease",
    "&:hover": {
      transform: "translateY(-6px)",
      borderColor: "rgba(22,139,255,.33)",
      boxShadow: "0 22px 46px rgba(0,0,0,.23)",
    },
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      width: 3,
      height: 64,
      left: theme.direction === "rtl" ? "auto" : 0,
      right: theme.direction === "rtl" ? 0 : "auto",
      borderRadius: 10,
      background: "linear-gradient(#168bff,transparent)",
    },
  },
  coreIcon: {
    width: 50,
    height: 50,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 17,
    borderRadius: 14,
    color: "#2c9bff",
    background: "rgba(22,139,255,.075)",
    border: "1px solid rgba(22,139,255,.15)",
  },
  coreTitle: {
    color: "#f2f6fb",
    fontWeight: 800,
    fontSize: "clamp(1.1rem,1.7vw,1.35rem)",
    lineHeight: 1.5,
    marginBottom: 11,
    textAlign: theme.direction === "rtl" ? "right" : "left",
  },
  coreDesc: {
    color: "#8f9db2",
    fontSize: 13,
    lineHeight: 1.95,
    margin: 0,
    textAlign: theme.direction === "rtl" ? "right" : "left",
  },
}));

export default function AboutScreen() {
  const classes = useStyles();
  const translate = getTranslate();
  const calculatedAge = calculateAge();
  const age = translate.locale === "fa" ? toPersianDigits(calculatedAge) : calculatedAge;

  const infoItems = [
    { icon: <PersonOutlineIcon className={classes.infoIcon} />, label: translate.fullname, value: translate.name },
    { icon: <PersonOutlineIcon className={classes.infoIcon} />, label: translate.age, value: age },
    { icon: <LanguageOutlinedIcon className={classes.infoIcon} />, label: translate.languages, value: `${translate.persian} | ${translate.english}` },
    { icon: <RoomOutlinedIcon className={classes.infoIcon} />, label: translate.address, value: translate.street },
    { icon: <PhoneIphoneOutlinedIcon className={classes.infoIcon} />, label: translate.phone, value: translate.tel },
    { icon: <CheckCircleOutlineOutlinedIcon className={classes.infoIcon} />, label: translate.availabilityLabel, value: translate.available },
  ];

  const icons = {
    ai: <MemoryIcon />,
    cv: <VisibilityOutlinedIcon />,
    software: <CodeOutlinedIcon />,
  };

  return (
    <div className={`${classes.root} modern-page`}>
      <div className={classes.inner}>
        <Title title={translate.aboutme} eyebrow={translate.aboutEyebrow} />

        <div className={classes.heroCard}>
          <Grid container spacing={3} alignItems="stretch">
            <Grid item xs={12} lg={5}>
              <div className={classes.imageWrap}>
                <img src={aboutImg} alt={translate.aboutImageAlt} className={classes.image} />
              </div>
            </Grid>

            <Grid item xs={12} lg={7}>
              <div className={classes.content}>
                <Typography component="h2" className={classes.nameTitle}>
                  {translate.hi}<span className={classes.accent}>{translate.name}</span>{translate.hi2}
                </Typography>

                <Typography className={classes.description}>{translate.aboutDescription}</Typography>
                <div className={classes.journeyNote}>{translate.aboutJourney}</div>

                <div className={classes.tags}>
                  {translate.aboutFocusTags.map((tag) => (
                    <Chip key={tag} label={tag} className={classes.tag} variant="outlined" />
                  ))}
                </div>

                <Grid container spacing={1}>
                  {infoItems.map((item, index) => (
                    <Grid item xs={12} sm={6} key={`${item.label}-${index}`}>
                      <div className={classes.infoItem}>
                        {item.icon}
                        <div>
                          <div className={classes.infoLabel}>{item.label}</div>
                          <div className={classes.infoValue}>{item.value}</div>
                        </div>
                      </div>
                    </Grid>
                  ))}
                </Grid>

                <div className={classes.actions}>
                  <Button component="a" href="/Mehdi_Talebi_Resume.pdf" download className={classes.primaryButton}>
                    <span className={classes.buttonInner}><span>{translate.downloadcv}</span><GetAppIcon fontSize="small" /></span>
                  </Button>

                  <Button component={Link} to="/portfolio" className={classes.secondaryButton}>
                    <span className={classes.buttonInner}><span>{translate.viewProjects}</span><ArrowForwardRoundedIcon className={classes.arrowIcon} fontSize="small" /></span>
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>

        <section className={classes.coreSection}>
          <Title title={translate.coreAreasTitle} eyebrow={translate.coreAreasEyebrow} />

          <Grid container spacing={3}>
            {translate.coreAreas.map((item) => (
              <Grid item xs={12} md={6} lg={4} key={item.id}>
                <div className={classes.coreCard}>
                  <div className={classes.coreIcon}>{icons[item.icon]}</div>
                  <Typography component="h3" className={classes.coreTitle}>{item.title}</Typography>
                  <p className={classes.coreDesc}>{item.desc}</p>
                </div>
              </Grid>
            ))}
          </Grid>
        </section>
      </div>
    </div>
  );
}
